import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../brand/Logo";
import { useLang } from "../../i18n/LanguageContext";
import { MapPin, Mail } from "lucide-react";

export function PublicFooter() {
  const { t } = useLang();
  return (
    <footer data-testid="public-footer" className="bg-sambiva-green text-sambiva-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo className="h-11 mb-4" />
          <p className="font-script text-2xl text-sambiva-yellow mb-3">{t("footer.tagline")}</p>
          <p className="text-sm text-sambiva-cream/80 leading-relaxed">{t("footer.newsletter")}</p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">{t("footer.explore")}</h4>
          <ul className="space-y-2 text-sm text-sambiva-cream/85">
            <li><Link to="/products" className="hover:text-sambiva-yellow transition-colors">{t("nav.products")}</Link></li>
            <li><Link to="/recipes" className="hover:text-sambiva-yellow transition-colors">{t("nav.recipes")}</Link></li>
            <li><Link to="/our-story" className="hover:text-sambiva-yellow transition-colors">{t("nav.story")}</Link></li>
            <li><Link to="/where-to-buy" className="hover:text-sambiva-yellow transition-colors">{t("nav.whereToBuy")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">{t("footer.trade")}</h4>
          <ul className="space-y-2 text-sm text-sambiva-cream/85">
            <li><Link to="/trade" className="hover:text-sambiva-yellow transition-colors">{t("nav.trade")}</Link></li>
            <li><Link to="/partner" className="hover:text-sambiva-yellow transition-colors">{t("nav.becomePartner")}</Link></li>
            <li><Link to="/trade/login" className="hover:text-sambiva-yellow transition-colors">{t("nav.tradeLogin")}</Link></li>
            <li><Link to="/contact" className="hover:text-sambiva-yellow transition-colors">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">{t("footer.company")}</h4>
          <div className="text-sm text-sambiva-cream/85 space-y-3">
            <p className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0 text-sambiva-yellow" />
              <span>Sambiva · GST Foods<br />Rua das Olarias, Number 10<br />6000-176 Castelo Branco<br />Portugal</span>
            </p>
            <p className="flex items-center gap-2">
              <Mail size={16} className="text-sambiva-yellow" /> hello@sambiva.com
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-sambiva-cream/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-sambiva-cream/70">
          <p>© {new Date().getFullYear()} Sambiva · GST Foods. {t("footer.rights")}</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-sambiva-yellow">{t("footer.privacy")}</Link>
            <Link to="/cookies" className="hover:text-sambiva-yellow">{t("footer.cookies")}</Link>
            <Link to="/terms" className="hover:text-sambiva-yellow">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
